<template>
  <v-card>
    <v-toolbar flat color="primary" dark>
      <v-toolbar-title>Workspace Library</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="$emit('close')"><v-icon>close</v-icon></v-btn>
    </v-toolbar>
    <v-card flat style="height: 80vh; overflow-y: hidden;">
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <workspace-resource-list @addToContext="addToContext"></workspace-resource-list>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
  </v-card>
</template>

<script>
import WorkspaceResourceList from './WorkspaceResourceList';
import { mapActions, mapGetters } from 'vuex';
export default {
  components: { WorkspaceResourceList },
  data() {
    return {
      tabPage: 0
    };
  },
  computed: {
    ...mapGetters('context', ['context'])
  },
  methods: {
    ...mapActions('resources', ['addResourceToContext']),
    addToContext(resourceId) {
      this.addResourceToContext({ resourceId, context: this.context });
    }
  }
};
</script>
